import { useMemo, type ReactNode } from 'react';

import { OnboardingTransitionContext } from './onboardingTransitionContext';
import type { SlotId } from './screens/strategySummary';

type ProviderProps = {
	children: ReactNode;
	completeOnboarding: (pillars: SlotId[]) => void;
	pillarsOverride?: SlotId[] | null;
};

export const OnboardingTransitionProvider = ({
	children,
	completeOnboarding,
	pillarsOverride = null,
}: ProviderProps) => {
	const value = useMemo(
		() => ({ completeOnboarding, pillarsOverride }),
		[completeOnboarding, pillarsOverride],
	);
	return (
		<OnboardingTransitionContext.Provider value={value}>
			{children}
		</OnboardingTransitionContext.Provider>
	);
};
